import React from "react";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";

/**
 * Reusable right-side sliding drawer with a consistent header (title + optional
 * header actions + close button), scrollable body, and optional footer.
 * Built on MUI's Drawer so it gets a proper backdrop, focus trap and animation.
 *
 * Props:
 *   open          - boolean, controls visibility
 *   onClose       - called when the backdrop, Esc key, or close button is used
 *   title         - header title text/node
 *   headerActions - optional node rendered before the close button (e.g. "Mark all read")
 *   width         - drawer width, default 420 (px) — can be a css value too
 *   footer        - optional node pinned to the bottom of the drawer
 *   children      - drawer body content (scrolls independently)
 */
const SideDrawer = ({ open, onClose, title, headerActions, width = 420, footer, children }) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        width,
        maxWidth: "100vw",
        display: "flex",
        flexDirection: "column",
      },
    }}
  >
    {/* header */}
    <div
      className="flex items-center justify-between px-4 py-3 flex-shrink-0"
      style={{ background: "var(--app-button-color, #a70e13)", color: "#fff" }}
    >
      <span className="text-base font-bold">{title}</span>
      <div className="flex items-center gap-2">
        {headerActions}
        <button
          onClick={onClose}
          className="p-1 rounded-full hover:bg-white/15 transition-colors"
          style={{ color: "#fff" }}
          aria-label="Close"
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </button>
      </div>
    </div>

    <Divider />

    {/* body */}
    <div className="flex-1 overflow-y-auto">{children}</div>

    {/* footer */}
    {footer && (
      <>
        <Divider />
        <div className="flex-shrink-0">{footer}</div>
      </>
    )}
  </Drawer>
);

export default SideDrawer;
